import { render, staticRenderFns } from "./modal-token-expired.vue?vue&type=template&id=02873697&"
import script from "./modal-token-expired.vue?vue&type=script&lang=js&"
export * from "./modal-token-expired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports